import React, { useState } from 'react';
import arrowUpIcon from '../../../../../../assets/image/arrow_up.svg';
import arrowDownIcon from '../../../../../../assets/image/arrowD.svg';

export default function InventorySummaryTableBodyComponent({
	data,
	params,
	periods,
	selectedColumnsList,
}) {
	const [isSelectedRows, setIsSelectedRows] = useState([]);
	const handleArrowIcon = (productId) => {
		setIsSelectedRows((prev) =>
			prev.includes(productId) ? prev.filter((item) => item !== productId) : [...prev, productId],
		);
	};

	const getProductRowKey = (productIndex) => `product-${productIndex}`;

	return data.flatMap((product, productIndex) => {
		const productRowKey = getProductRowKey(productIndex);
		const isOpen = isSelectedRows.includes(productRowKey);

		// Product row
		const ProductRow = (
			<tr key={`product-${productIndex}`}>
				<td
					className="name-col"
					style={{ paddingLeft: '30px' }}
				>
					{product.batches && product.batches.length > 0 && (
						<img
							src={isOpen ? arrowUpIcon : arrowDownIcon}
							alt="arrow-icon"
							className="cursor-pointer"
							onClick={() => handleArrowIcon(productRowKey)}
						/>
					)}
					{product.product_name} ({product.product_code})
				</td>

				{periods.map((p, i) => {
					const key = p.label.trim().replace(/\s+/g, '_').toLowerCase();

					const metrics = product.metrics?.[key] || {};

					return selectedColumnsList.map((m, idx) => (
						<td key={`product-${productIndex}-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
					));
				})}
			</tr>
		);

		// Batch rows
		const batchRows =
			isOpen && product.batches && product.batches.length > 0
				? product.batches.map((batch, batchIndex) => (
						<tr key={`batch-${productIndex}-${batchIndex}`}>
							<td
								className="name-col"
								style={{
									paddingLeft: '60px',
								}}
							>
								{batch.batch_no || 'Unknown Batch'}
							</td>

							{periods.map((p, i) => {
								const key = p.label.trim().replace(/\s+/g, '_').toLowerCase();

								const metrics = batch.metrics?.[key] || {};

								return selectedColumnsList.map((m, idx) => (
									<td key={`batch-${productIndex}-${batchIndex}-${i}-${idx}`}>
										{metrics[m.key] ?? 0}
									</td>
								));
							})}
						</tr>
					))
				: [];

		return [ProductRow, ...batchRows];
	});
}
